import { useState } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import {
  getReactSelectValue,
  ReactSelectInput,
} from '@hivebrite/design-system/Inputs';

import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { DividerItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/dividerItemAttributes';

const options = [
  {
    label: __('Solid'),
    value: 'solid',
  },
  {
    label: __('Dashed'),
    value: 'dashed',
  },
  {
    label: __('Dotted'),
    value: 'dotted',
  },
];

const DividerStyle = ({
  defaultAttributes,
  item,
  onChange,
}: ComponentSettingsTab<DividerItemAttributes>) => {
  const [value, setValue] = useState(
    // TODO: remove defaultAttributes and include it directly in the JSON if needed
    item.attributes?.dividerStyle || defaultAttributes.dividerStyle,
  );

  const handleChange = (e) => {
    setValue(e.value);

    onChange({
      id: item.id,
      settingKey: 'attributes.dividerStyle',
      value: e.value,
    });
  };

  const valueSelected = getReactSelectValue(options, value);

  return (
    <Wrapper>
      <InputTitle id="settingsDivider-input" label={__('Divider')} />
      <ReactSelectInput
        id="settingsDivider"
        name="settingsDivider"
        onChange={handleChange}
        options={options}
        variant="small"
        value={valueSelected}
        width={155}
      />
    </Wrapper>
  );
};

export default DividerStyle;

const Wrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  mb: 4,
}))``;
